import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress,
    Typography,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    open: boolean;
    status: 'saving' | 'success' | 'error';
    message?: string;
    onClose: () => void;
}

const SaveStatusDialog: React.FC<Props> = ({ open, status, message, onClose }) => {
    return (
        <Dialog open={open} maxWidth="xs" fullWidth>
            <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {status === 'saving' && "Saving..."}
                {status === 'success' && "Saved Successfully"}
                {status === 'error' && "Save Failed"}
                {(status === 'error' || status === 'success') && (
                    <IconButton size="small" onClick={onClose}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                )}
            </DialogTitle>

            <DialogContent style={{ textAlign: 'center', paddingBottom: '24px' }}>
                {status === 'saving' && <CircularProgress />}
                <Typography variant="body1" mt={2}>
                    {status === 'saving' && "Please wait while we save your changes."}
                    {status === 'success' && "Changes were saved successfully."}
                </Typography>

                {status === 'error' && (
                    <div style={{ maxHeight: '200px', overflowY: 'auto', fontSize: '0.9rem', marginTop: '10px' }}>
                        {message ? (message.length > 255 ? message.substring(0, 255) + "..." : message) : "An unknown error occurred."}
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default SaveStatusDialog;
